import React, { useState } from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { ArrowUpRight, Calendar } from "lucide-react";

const NewsItem = ({ imageUrl, name, description, newsId, date }) => {
  const [hover, setHover] = useState(false);
  const { t } = useTranslation();

  return (
    <Link href={`/news/${newsId}`} passHref style={{ textDecoration: "none", display: "block", height: "100%" }}>
      <div
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          height: "100%",
          display: "flex", flexDirection: "column",
          background: "#ffffff",
          borderRadius: 20,
          overflow: "hidden",
          border: "1px solid rgba(226,232,240,0.8)",
          boxShadow: hover ? "0 20px 48px rgba(0,71,171,0.14), 0 4px 12px rgba(0,0,0,0.05)" : "0 4px 20px rgba(0,71,171,0.07), 0 1px 4px rgba(0,0,0,0.03)",
          transform: hover ? "translateY(-6px)" : "translateY(0)",
          transition: "all 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
          cursor: "pointer",
        }}
      >
        {/* Image */}
        <div style={{ position: "relative", height: 220, overflow: "hidden", flexShrink: 0 }}>
          <div style={{
            width: "100%", height: "100%",
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: "cover", backgroundPosition: "center",
            transform: hover ? "scale(1.08)" : "scale(1)",
            transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
          }} />
          {/* Gradient overlay */}
          <div style={{
            position: "absolute", inset: 0,
            background: "linear-gradient(to top, rgba(0,16,60,0.5) 0%, transparent 55%)",
          }} />
          {/* Date badge */}
          {date && (
            <div style={{
              position: "absolute", top: 14, left: 14,
              display: "flex", alignItems: "center", gap: 5,
              background: "rgba(0,16,60,0.65)",
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(255,255,255,0.2)",
              color: "#fff", borderRadius: 8,
              padding: "5px 11px", fontSize: 12, fontWeight: 500,
            }}>
              <Calendar size={11} />
              {date}
            </div>
          )}
          {/* Arrow icon top-right on hover */}
          <div style={{
            position: "absolute", top: 14, right: 14,
            width: 36, height: 36,
            background: "#0047AB",
            borderRadius: 10,
            display: "flex", alignItems: "center", justifyContent: "center",
            opacity: hover ? 1 : 0,
            transform: hover ? "scale(1)" : "scale(0.7)",
            transition: "all 0.3s ease",
          }}>
            <ArrowUpRight size={16} color="white" />
          </div>
        </div>

        {/* Content */}
        <div style={{ padding: "20px 22px 22px", flexGrow: 1, display: "flex", flexDirection: "column" }}>
          <h3 style={{
            fontSize: 15, fontWeight: 700,
            color: "#0A0F1E",
            lineHeight: 1.55,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 3,
            overflow: "hidden",
            flexGrow: 1,
            marginBottom: 16,
            transition: "color 0.2s",
            ...(hover ? { color: "#0047AB" } : {}),
          }}>
            {name}
          </h3>

          {/* Read more */}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            paddingTop: 14,
            borderTop: "1px solid #F1F5F9",
          }}>
            <span style={{
              fontSize: 13, fontWeight: 600,
              color: hover ? "#0047AB" : "#94A3B8",
              transition: "color 0.2s",
            }}>
              {t("read_more") || "Дэлгэрэнгүй"}
            </span>
            <div style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: 28, height: 28,
              background: hover ? "#EFF6FF" : "#F8FAFC",
              borderRadius: 8,
              transition: "all 0.2s",
            }}>
              <ArrowUpRight size={13} color={hover ? "#0047AB" : "#94A3B8"} />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default NewsItem;
